import { FC, useCallback, useState } from 'react';
import Modal from '../../components/shared/Modal/Modal';
import Selector from '../../components/shared/Selector/Selector';
import { ServiceSupplier } from '../../services/service-supplier';
import { NotificationManager } from "react-notifications";
import Tabs from '../../components/shared/Tabs';
import { useTranslation, Trans } from 'react-i18next';

type Props = {
  show: boolean,
  setShow: (value: boolean) => void,
  areas: any[],
  onSave: (modifiedAreaId: string) => void,
}

const RecategorizeModal : FC<Props> = ({ show, setShow, areas, onSave }) => {
  const [t] = useTranslation('supplierDatabase', { keyPrefix: 'recategorize' });
  const [sourceAreaId, setSourceAreaId] = useState(null);
  const [areaIdToChange, setAreaIdToChange] = useState(null);
  const [tab, setTab] = useState(0);

  const recategorizeSuppliers = useCallback(async () => {
    if (sourceAreaId && areaIdToChange) {
      const response = await ServiceSupplier.recategorizeSuppliers(tab == 0 ? "ADD" : "REMOVE", sourceAreaId, areaIdToChange);
      const updatedText = t('updatedText', '{{count}} leverantörer uppdaterade', { count: response.updatedSuppliers.length });
      const errorText = t('errorText', '{{count}} leverantörer ej uppdaterade', { count: response.errors.length });
      if (response.errors.length) {
        NotificationManager.error(
          t('notification.error.description', 'Omkategoriseringen har sparats: {{updatedText}}, {{errorText}}.', { updatedText, errorText }),
          t('notification.error.title', 'Något gick fel')
        );
      } else {
        NotificationManager.success(
          t('notification.success.description', 'Omkategoriseringen har sparats: {{updatedText}}.', { updatedText }),
          t('notification.success.title', 'Sparat')
        );
      }
      onSave(areaIdToChange);
      setShow(false);
    }
  }, [tab, sourceAreaId, areaIdToChange, setShow]);

  return (
    <Modal
      show={show}
      setShow={setShow}
      title={t('title','Omkategorisera')}
      buttonInfo={{ label: t('button.save', 'Spara'), action: recategorizeSuppliers }}
    >
      <div style={{fontSize: "14px", color: "var(--gray-700)", display: "flex", gap: "16px", flexDirection: "column"}}>
        <Tabs tabs={[t('tabs.add', 'Lägg till'), t('tabs.remove', 'Ta bort')]} selected={tab} onChange={setTab} />
        {tab === 0 && (
          <Trans t={t} i18nKey="add">
            Lägg till alla leverantörer i
            <Selector
              placeholder={t('placeholder.category', 'Kategori')}
              options={areas}
              value={sourceAreaId ? areas.find(area => area.value == sourceAreaId) : null}
              onChange={event => setSourceAreaId(event?.value)}
            />
            till
            <Selector
              placeholder={t('placeholder.otherCategory', 'Annan kategori')}
              options={areas}
              value={areaIdToChange ? areas.find(area => area.value == areaIdToChange) : null}
              onChange={event => setAreaIdToChange(event?.value)}
            />
          </Trans>
        )}
        {tab === 1 && (
          <Trans t={t} i18nKey="remove">
            Ta bort alla leverantörer i
            <Selector
              placeholder={t('placeholder.category', 'Kategori')}
              options={areas}
              value={sourceAreaId ? areas.find(area => area.value == sourceAreaId) : null}
              onChange={event => setSourceAreaId(event?.value)}
            />
            från
            <Selector
              placeholder={t('placeholder.otherCategory', 'Annan kategori')}
              options={areas}
              value={areaIdToChange ? areas.find(area => area.value == areaIdToChange) : null}
              onChange={event => setAreaIdToChange(event?.value)}
            />
          </Trans>
        )}
      </div>

    </Modal>
  );

}

export default RecategorizeModal;
